import { TProjectsListState } from 'shared/reducers';

export const selectLimit = (state: TProjectsListState) => {
  return state.limit;
};
